import axiosPost from '../axiosPost';

export const registrosIns = async (arg) => {
    const { nombre, codigo, descripcion, bo, tipoDeRegistro } = arg;

    const body = {
        "service": "RegistroIns",
        "params": {
            "registroNombre": nombre,
            "registroCod": codigo,
            "registroDescripcion": descripcion,
            "registroRequiereBO": bo,
            "tipoRegistroId": tipoDeRegistro
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}